import React from 'react';
import { graphql } from 'gatsby';
import { FormRenderer } from '../../FormRenderer';

export const Form = ({ data }) => (
  <FormRenderer form={data.form} formGuid={data.formGuid} />
);

export const FormQuery = graphql`
  fragment FormQuery on UMBRACO_FormComponentType {
    ...Form
  }
`;
